import React, {
  forwardRef,
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

// react datepicker
import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

import { Controller, useFormContext } from "react-hook-form";

import { ButtonAddressSearch, itemRowSpacing, SubTitle } from "../index";

import AddressSearch from "../AddressSearch";
import AddressBook from "./AddressBook";
import LatestAddress from "./LatestAddress";

import { convertPhone } from "../../lib";

const useStyles = makeStyles(() => ({
  latestContainer: {
    marginTop: 12,
  },
  addressBase: {
    width: 260,
  },
  buttonContainer: {
    marginLeft: 11,
  },
  addressBookButton: {
    display: "inline-block",
    minWidth: 43,
    minHeight: 28,
    marginTop: 20, // 주소 검색 버튼을 기본주소 밑 보더에 맞추기
    marginLeft: 7,
    fontSize: 11,
  },
  deleteButton: {
    display: "inline-block",
    minWidth: 43,
    minHeight: 28,
    marginTop: 20, // 주소 검색 버튼을 기본주소 밑 보더에 맞추기
    marginLeft: 7,
    fontSize: 11,
  },
  gridAddressDetail: {
    marginLeft: 73,
  },
  optionAddingArrival: {
    marginTop: -7,
    marginLeft: 20,
    "& span:nth-child(1)": {
      marginRight: -2,
    },
    "& span:nth-child(2)": {
      marginTop: 2,
    },
  },
}));

const AddressBase = (props: any) => {
  const classes = useStyles();
  const { name, showSearchAddressPage } = props;
  const { register } = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

  return (
    <TextField
      {...register(name)}
      defaultValue={""}
      InputProps={{ readOnly: true }}
      required
      fullWidth
      variant={"standard"}
      InputLabelProps={{
        shrink: true,
      }}
      label={"주소"}
      className={classes.addressBase}
      onClick={showSearchAddressPage}
    />
  );
};

const AddressDetail = (props: any) => {
  const { name } = props;
  const { register } = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

  return (
    <TextField
      {...register(name)}
      inputProps={{
        maxLength: 50,
      }}
      variant={"standard"}
      fullWidth
      defaultValue={""}
      placeholder={"상세주소를 입력해주세요"}
    />
  );
};

const AddressBaseJibun = (props: any) => {
  const { name, base } = props;
  const { register } = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

  return <input {...register(name)} type={"hidden"} value={base} />;
};

const AddressBookButton = (props: any) => {
  const classes = useStyles();
  const { setShowAddressBookPage } = props;

  return (
    <Button
      variant="contained"
      size="small"
      color="secondary"
      className={classes.addressBookButton}
      onClick={() => {
        console.log("운송주문-주소록 열기");
        window.gtag("event", `운송주문-주소록 열기`, {
          user_id: localStorage.getItem("customerName") || "none",
        });
        setShowAddressBookPage(true);
      }}
    >
      주소록
    </Button>
  );
};

const PlaceName = (props: any) => {
  const { name } = props;
  const { register, setValue } = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

  return (
    <TextField
      {...register(name)}
      fullWidth
      defaultValue={""}
      variant={"standard"}
      required
      label={"장소명"}
      InputLabelProps={{ shrink: true }} // shrink: false 면 label 이 placeholder 역할을 함
      inputProps={{ maxLength: 12 }}
      placeholder={"ex) 생산공장1"}
      onChange={(e: any) => {
        if (name === "departure.name") setValue(name, e.target.value);
        if (name === "arrival.name") setValue(name, e.target.value);
        if (name === "waypoint0.name") setValue(name, e.target.value);
        if (name === "waypoint1.name") setValue(name, e.target.value);
      }}
    />
  );
};

const PlaceMemo = (props: any) => {
  const { name } = props;
  const { register, setValue } = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

  return (
    <TextField
      {...register(name)}
      fullWidth
      defaultValue={""}
      variant={"standard"}
      required
      label={"메모"}
      InputLabelProps={{ shrink: true }} // shrink: false 면 label 이 placeholder 역할을 함
      inputProps={{ maxLength: 12 }}
      placeholder={"ex) 2PT 하차"}
      onChange={(e: any) => {
        if (name === "departure.memo") setValue(name, e.target.value);
        if (name === "arrival.memo") setValue(name, e.target.value);
        if (name === "waypoint0.memo") setValue(name, e.target.value);
        if (name === "waypoint1.memo") setValue(name, e.target.value);
      }}
    />
  );
};

const Phone = (props: any) => {
  const { name } = props;
  const { register } = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

  return (
    <TextField
      {...register(name)}
      fullWidth
      defaultValue={""}
      required
      variant={"standard"}
      InputLabelProps={{ shrink: true }} // shrink: false 면 label 이 placeholder 역할을 함
      label={"핸드폰 번호"}
      placeholder={"ex) 010-xxxx-xxxx"}
      onChange={(e: any) => {
        e.target.value = convertPhone(e.target.value);
      }}
    />
  );
};

const SelectDate = (props: any) => {
  const { name } = props;
  const { control, setValue, getValues } = useFormContext();

  const CustomInput = forwardRef(({ value, onClick }: any, ref) => (
    <TextField
      required
      value={value}
      onClick={() => {
        console.log("운송주문-날짜/시간 선택");

        window.gtag("event", `운송주문-날짜/시간 선택`, {
          user_id: localStorage.getItem("customerName") || "none",
        });
        onClick();
      }}
      variant={"standard"}
      InputLabelProps={{
        shrink: true,
      }}
      label={"날짜/시간"}
      fullWidth
      sx={{ maxWidth: 190 }}
    />
  ));
  let departureDate = getValues("departure.date");
  let waypoint0Date = getValues("waypoint0.date");
  let waypoint1Date = getValues("waypoint1.date");

  const filterPassedTime = (time: any) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);
    if (name === "departure.date")
      return currentDate.getTime() < selectedDate.getTime();
    if (name === "waypoint0.date")
      return departureDate < selectedDate.getTime();
    if (name === "waypoint1.date") {
      if (waypoint0Date) {
        return waypoint0Date < selectedDate.getTime();
      } else {
        return departureDate < selectedDate.getTime();
      }
    }
    if (name === "arrival.date") {
      if (waypoint1Date) {
        return waypoint1Date < selectedDate.getTime();
      } else if (waypoint0Date) {
        return waypoint0Date < selectedDate.getTime();
      } else {
        return departureDate < selectedDate.getTime();
      }
    }

    return true;
  };
  const getMinDate = (name: string): Date => {
    if (name === "departure.date") return new Date();
    else if (name === "waypoint0.date") return departureDate;
    else if (name === "waypoint1.date") return waypoint0Date;
    else return waypoint1Date || waypoint0Date || departureDate || new Date();
  };

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <DatePicker
          {...field}
          locale={ko} // 언어설정 기본값은 영어
          dateFormat="M월 d일, aa h시 mm분" // 날짜 형식 설정
          minDate={getMinDate(name)} // 선택할 수 있는 최소 날짜값 지정
          filterTime={filterPassedTime}
          placeholderText="날짜/시간 선택" // placeholder
          selected={field.value}
          onChange={(date: Date) => {
            console.log("운송주문-날짜/시간 선택완료");

            window.gtag("event", `운송주문-날짜/시간 선택완료`, {
              user_id: localStorage.getItem("customerName") || "none",
            });
            date.setSeconds(0);
            field.onChange(date);
            if (name === "departure.date") setValue(name, date);
            if (name === "arrival.date") setValue(name, date);
            if (name === "waypoint0.date") setValue(name, date);
            if (name === "waypoint1.date") setValue(name, date);
          }}
          showTimeSelect
          customInput={<CustomInput />}
        />
      )}
    />
  );
};

export const AddressFormWayPoint = (props: any) => {
  const { name, waypoint, setWaypoint } = props;

  const classes = useStyles();
  const { setValue, register, watch, unregister } = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용
  const [showSearchAddressPage, setShowSearchAddressPage] =
    useState<boolean>(false);
  const [showAddressBookPage, setShowAddressBookPage] =
    useState<boolean>(false);
  const [addressBaseJibun, setAddressBaseJibun] = useState<string>("");

  const setAddressForm = useCallback(
    (a: any) => {
      setValue(name, {
        addressBase: a.addressBase,
        addressDetail: a.addressDetail,
        name: a.name,
        phone: a.phone,
        placeInfoForCustomer: a.placeInfoForCustomer,
        date:
          name === "waypoint0" ? watch("waypoin0Date") : watch("waypoint1Date"),
        placeInfo: a.placeInfoForCustomer,
        memo: "",
      });
    },
    [name, setValue]
  );

  const setAddress = useCallback(
    (base: string) => {
      setValue(name, {
        addressBase: base,
        addressDetail: "",
        name: "",
        phone: "",
        date: "",
        placeInfo: "",
        memo: "",
      });
    },
    [name, setValue]
  );

  return (
    <Fragment>
      <Grid container justifyContent={"space-between"}>
        <Grid container justifyContent={"space-between"}>
          <Grid item>
            <SubTitle>{"경유지"}</SubTitle>
          </Grid>
          <Grid item>
            <Button
              className={classes.deleteButton}
              size={"small"}
              color={"error"}
              variant={"contained"}
              onClick={() => {
                unregister(name);
              }}
            >
              삭제
            </Button>
          </Grid>
        </Grid>
        <Grid item sx={{ mt: 4 }}>
          <AddressSearch
            open={showSearchAddressPage}
            close={(isSelectedAddress: boolean) => {
              setShowSearchAddressPage(false);
            }}
            setAddress={setAddress}
            setAddressBaseJibun={setAddressBaseJibun}
          />
          <AddressBook
            name={name}
            open={showAddressBookPage}
            //setLatest={setLatest}
            close={() => setShowAddressBookPage(false)}
            setAddressForm={setAddressForm}
          />
        </Grid>

        <Grid container direction={"column"} spacing={itemRowSpacing}>
          <Grid item>
            <Grid container direction={"column"} spacing={itemRowSpacing}>
              <Grid item>
                <Grid
                  container
                  direction={"row"}
                  justifyContent={"space-between"}
                >
                  <Grid item>
                    <AddressBase
                      name={`${name}.addressBase`}
                      showSearchAddressPage={() =>
                        setShowSearchAddressPage(true)
                      }
                    />
                  </Grid>
                  <Grid item className={classes.buttonContainer}>
                    <ButtonAddressSearch
                      onClick={() => setShowSearchAddressPage(true)}
                    />
                    <AddressBookButton
                      setShowAddressBookPage={setShowAddressBookPage}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <AddressDetail name={`${name}.addressDetail`} />
                <AddressBaseJibun
                  name={`${name}.addressBaseJibun`}
                  base={addressBaseJibun}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <PlaceName
                  name={`${name}.name`}
                  isDeparture={name === "departure"}
                />
              </Grid>
              <Grid item xs={6}>
                <Phone name={`${name}.phone`} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item spacing={3}>
            <Grid item xs={6}>
              <SelectDate
                name={`${name}.date`}
                isDeparture={name === "departure"}
              />
            </Grid>
            <Grid item xs={6}></Grid>
          </Grid>
          <Grid item spacing={3}>
            <PlaceMemo name={`${name}.memo`} />
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default function AddressForm(props: any) {
  const classes = useStyles();

  const { name, title, latestAddresses } = props;

  const isDeparture: boolean = name === "departure";
  const [showSearchAddressPage, setShowSearchAddressPage] =
    useState<boolean>(false);
  const [showAddressBookPage, setShowAddressBookPage] =
    useState<boolean>(false);
  const [addressBaseJibun, setAddressBaseJibun] = useState<string>("");
  const [latest, setLatest] = useState(name === "departure" ? "0" : "");

  const { setValue, register, watch } = useFormContext(); //하위 form 들에 있는 값을 가지고 오기 위해 사용

  const setAddressForm = useCallback(
    (a: any) => {
      setValue(name, {
        addressBase: a.addressBase,
        addressDetail: a.addressDetail,
        name: a.name,
        phone: a.phone,
        placeInfoForCustomer: a.placeInfoForCustomer,
        date: isDeparture ? watch("departureDate") : watch("arrivalDate"),
      });
      isDeparture
        ? setValue("departureName", a.name)
        : setValue("arrivalName", a.name);
    },
    [name, setValue]
  );

  const setAddress = useCallback(
    (base: string) => {
      setValue(name, {
        addressBase: base,
        addressDetail: "",
        name: "",
        phone: "",
        date: isDeparture ? watch("departureDate") : watch("arrivalDate"),
      });
      isDeparture ? setValue("departureName", "") : setValue("arrivalName", "");
    },
    [name, setValue]
  );

  const prefillInDeparture = useCallback(
    (name: string, latestAddressList: any) => {
      if (isDeparture) {
        const addressForm = latestAddressList?.departure?.[0];
        if (addressForm) setAddressForm(addressForm);
      }
    },
    [setAddressForm]
  );

  const updateSidebar = useCallback(
    (index: number) => {
      if (isDeparture) {
        setValue(
          "departureName",
          latestAddresses?.departure?.[index]?.name || ""
        );
      } else {
        setValue("arrivalName", latestAddresses?.arrival?.[index]?.name || "");
      }
    },
    [latestAddresses]
  );

  const cleanUpSidebar = useCallback(() => {
    if (isDeparture) {
      setValue("departureName", "");
    } else {
      setValue("arrivalName", "");
    }
  }, []);

  useEffect(() => {
    prefillInDeparture(name, latestAddresses);
  }, [prefillInDeparture, name, latestAddresses]);

  return (
    <Fragment>
      <Grid container>
        <Grid item>
          <SubTitle>{title}</SubTitle>
        </Grid>
        {name === "arrival" ? (
          <Grid item className={classes.optionAddingArrival}>
            <FormControlLabel
              control={
                <Checkbox
                  sx={{ zIndex: 0 }}
                  defaultChecked={true}
                  {...register("optionAddingArrival")}
                  color={"primary"}
                />
              }
              label={"주소록에 등록"}
            />
          </Grid>
        ) : (
          <></>
        )}
      </Grid>
      <AddressSearch
        open={showSearchAddressPage}
        close={(isSelectedAddress: boolean) => {
          setShowSearchAddressPage(false);
          if (isSelectedAddress) {
            setLatest("");
            cleanUpSidebar();
          }
        }}
        setAddress={setAddress}
        setAddressBaseJibun={setAddressBaseJibun}
      />
      <AddressBook
        name={name}
        open={showAddressBookPage}
        setLatest={setLatest}
        close={() => setShowAddressBookPage(false)}
        setAddressForm={setAddressForm}
      />
      <Grid container direction={"column"} spacing={itemRowSpacing}>
        <Grid item className={classes.latestContainer}>
          <LatestAddress
            isDeparture={name === "departure"}
            setAddressForm={setAddressForm}
            updateSidebar={updateSidebar}
            latest={latest}
            setLatest={setLatest}
            latestAddresses={
              name === "departure"
                ? latestAddresses?.departure
                : latestAddresses?.arrival
            }
          />
        </Grid>
        <Grid item>
          <Grid container direction={"column"} spacing={itemRowSpacing}>
            <Grid item>
              <Grid
                container
                direction={"row"}
                justifyContent={"space-between"}
              >
                <Grid item>
                  <AddressBase
                    name={`${name}.addressBase`}
                    showSearchAddressPage={() => setShowSearchAddressPage(true)}
                  />
                </Grid>
                <Grid item className={classes.buttonContainer}>
                  <ButtonAddressSearch
                    onClick={() => setShowSearchAddressPage(true)}
                  />
                  <AddressBookButton
                    setShowAddressBookPage={setShowAddressBookPage}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <AddressDetail name={`${name}.addressDetail`} />
              <AddressBaseJibun
                name={`${name}.addressBaseJibun`}
                base={addressBaseJibun}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <PlaceName name={`${name}.name`} />
            </Grid>
            <Grid item xs={6}>
              <Phone name={`${name}.phone`} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item spacing={3}>
          <Grid item xs={6}>
            <SelectDate name={`${name}.date`} />
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}
